import { maxBoundingPoly } from '../selectors/detectionGaps';
import { DetectionGroups } from '../selectors/clusters';
import { GroupMapItem } from '../models';

import {
  DetectionBoundingPoly,
  DetectionGap,
  BoundingPolyRect,
} from '@common-modules/mediaDetails/models';

export const getBoundingPolySize = (boundingPoly: BoundingPolyRect) => ({
  width: boundingPoly[1].x - boundingPoly[0].x,
  height: boundingPoly[2].y - boundingPoly[1].y,
});

export const getBoundingPolyFromGap = (
  gap: DetectionGap,
  group: GroupMapItem | DetectionGroups['groupId'] | undefined,
  isDeleted?: boolean,
  newObjectId?: string,
  newLabel?: string,
  newGroupId?: string,
  convertToDetection?: boolean
): DetectionBoundingPoly => {
  const boundingPoly = maxBoundingPoly(gap);
  return {
    id: newObjectId || gap.id,
    size: getBoundingPolySize(boundingPoly),
    subsegmentId: gap.subsegmentId,
    groupId: newGroupId || gap.groupId,
    startTimeMs: gap.leftObject.stopTimeMs,
    stopTimeMs: gap.rightObject.startTimeMs,
    // g.leftObject can have stale attributes - use updated attributes from cluster
    shapeType: group?.shapeType,
    redactionCode: group?.redactionCode,
    redactionConfig: group?.redactionConfig,
    // version: undefined, // unclear if needed
    object: {
      ...gap.leftObject.object,
      label: newLabel || gap.leftObject.object.label,
      id: newObjectId || `${gap.id}_${gap.id}`, // this is weird!
      uri: `${gap.leftObject.object.uri}&uniq=${gap.id}`,
      boundingPoly,
      overlayObjectType: convertToDetection ? 'detection' : 'interpolation',
      ...(isDeleted && { isDeleted }),
    },
  };
};
